import script from "./DropDownFlowBite.vue?vue&type=script&setup=true&lang=js"
export * from "./DropDownFlowBite.vue?vue&type=script&setup=true&lang=js"

import "./DropDownFlowBite.vue?vue&type=style&index=0&id=447f7be3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-447f7be3"]])

export default __exports__